<template>
  <page
    :back-to="getPreviousUrl"
    title="Support Tickets"
    size="is-tablet"
    :loading="ticket === null"
  >
    <div slot="page-header-right" v-if="ticket !== null">
      <b-dropdown @input="update" v-model="form.status" position="is-bottom-left">
        <button
          class="button is-primary"
          type="button"
          slot="trigger"
          :class="{ 'is-loading': form.processing }"
        >
          <template v-if="form.status === 'open'">
            <b-icon icon="earth"></b-icon>
            <span>Нээлттэй</span>
          </template>

          <template v-if="form.status === 'closed'">
            <b-icon icon="account-multiple"></b-icon>
            <span>Хаагдсан</span>
          </template>

          <b-icon icon="menu-down"></b-icon>
        </button>

        <b-dropdown-item :value="'open'">
          <div class="media">
            <b-icon class="media-left" icon="earth"></b-icon>
            <div class="media-content">
              <h3>Нээлттэй</h3>
            </div>
          </div>
        </b-dropdown-item>

        <b-dropdown-item :value="'closed'">
          <div class="media">
            <b-icon class="media-left" icon="lock"></b-icon>
            <div class="media-content">
              <h3>Хаагдсан</h3>
            </div>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <ticket-reply-detail :ticket-id="$route.params.id"></ticket-reply-detail>
  </page>
</template>

<script>
import TicketReplyDetail from "./../../../../../components/TicketReplyDetail";

export default {
  components: {
    TicketReplyDetail
  },

  data() {
    return {
      ticket: null,

      form: null
    };
  },

  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  },

  created() {
    this.load();
  },

  watch: {
    ticket(ticket) {
      this.form = new window.Form({
        status: ticket.status
      });
    }
  },

  methods: {
    load() {
      this.$http
        .get(`/api/support/tickets/${this.$route.params.id}`)
        .then(response => {
          this.ticket = response.data.data;
        });
    },

    update() {
      this.form
        .takeAtLeast(300)
        .put(`/api/support/tickets/${this.$route.params.id}`)
        .then(() => {
          this.$buefy.toast.open("Төлөв амжилттай солигдлоо");
        });
    }
  }
};
</script>
